package app.bloomey.web.components.widgets

import androidx.compose.runtime.Composable
import app.bloomey.web.theme.toSitePalette
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.lightened
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.style.ComponentStyle
import com.varabyte.kobweb.silk.components.style.toModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*


val SiteTableStyle by ComponentStyle {
    val sitePalette = colorMode.toSitePalette()
    base {
        Modifier.background(color = sitePalette.background)
            .styleModifier {
                property("border-spacing", "unset")
            }
            .fontSize(0.9.em)
//            .borderCollapse(BorderCollapse.Collapse)
            .minWidth(400.px)
            .borderRadius(4.px)
    }
    cssRule(" th") {
        Modifier
            .textAlign(TextAlign.Start)
            .color(sitePalette.onBackgroundLight)
            .fontWeight(FontWeight.Normal)
            .borderBottom(
                width = .5.px,
                style = LineStyle.Solid,
                color = sitePalette.onBackground.lightened(.8f)
            )
    }

    cssRule(" tr:nth-child(even)") {
        Modifier.background(sitePalette.nearBackground)
    }
    cssRule(" thead tr") {
        Modifier.height(44.px)
            .borderBottom(1.px, style = LineStyle.Solid, sitePalette.onBackground)
    }
    cssRule(" tbody tr") {
        Modifier.cursor(Cursor.Pointer)
            .height(56.px)
            .wordBreak(WordBreak.BreakAll)
    }
    cssRule(" tr:hover") {
        Modifier.background(color = sitePalette.background.darkened(.02f))
    }
}

@Composable
fun <T> SiteTable(
    modifier: Modifier = Modifier,
    headers: List<String>,
    items: List<T>,
    itemModifier: (T) -> Modifier = { Modifier },
    dataBuilder: (T) -> List<@Composable () -> Unit>,
) {
    Table(attrs = Modifier.fillMaxWidth()
        .then(SiteTableStyle.toModifier())
        .then(modifier)
        .toAttrs {

        }) {
        Thead {
            Tr {
                headers.forEach {
                    Th { SpanText(it) }
                }
            }
        }
        Tbody {
            items.forEach { item ->
                Tr(attrs = Modifier.then(itemModifier(item)).toAttrs()) {
                    dataBuilder(item).forEach {
                        Td {
                            it()
                        }
                    }
                }
            }
        }
    }

}


@Composable
fun ShowingItems(modifier: Modifier = Modifier,count: Int) {
    Row(modifier = modifier.flexWrap(FlexWrap.Wrap).fontSize(FontSize.Medium)) {
        SpanText("Showing ")
        SpanText(
            "$count",
            modifier = Modifier.fontWeight(FontWeight.SemiBold)
        )
        SpanText(" items")
    }
}